module.exports = "../dist/img/white-25.2212.jpg";